export default {
  Search: {
    SearchPlaceHolder: 'Tìm kiếm',
    SearchEstimatePlaceHolder: 'Nhập nội dung cần tìm kiếm',
    SearchEnactHistory: 'Nhập mã, tên đơn vị cần tìm kiếm',
    SearchDictionaryList: 'Nhập mã, tên nội dung cần tìm kiếm',
    SearchExamine: 'Nhập tên đơn vị, mã QHNS để tìm kiếm',
    SearchOrganizationUnder: 'Tìm kiếm theo mã đơn vị, mã QHNS',
    SearchSortOrganizationChild: 'Tìm kiếm theo tên đơn vị, mã QHNS',
    SearchRoleManagement: 'Tìm kiếm theo vai trò',
    SearchExamineDetail: 'Nhập Nội dung để tìm kiếm...',
    SearchContent: 'Nhập nội dung cần tìm kiếm',
    SearchKeyWord: 'Nhập từ khóa cần tìm kiếm',
    AddButton: 'Thêm mới',
    AddButtonShortKey: 'Thêm mới (F9)',
    SubmitButton: 'Chọn',
    SubmitButtonShortKey: 'Chọn (Ctrl + S)',
    CancelButton: 'Hủy',
    SearchContextDictionary: 'Nhập mã, tên nội dung để tìm kiếm...',
    SearchApproveDictionary: 'Nhập Mã, Tên phí, lệ phí để tìm kiếm...',
    SearchReportList: 'Nhập tên báo cáo để tìm...',
  },
  Validate: {
    Duplicate: '{0} đã tồn tại trong danh sách. Bạn có muốn chương trình tự động cập nhật mã không?',
    DuplicateName: '{0} đã bị trùng trong danh sách nhập. Vui lòng kiểm tra lại.',
    DuplicateNameTree:
      'Đã tồn tại <span class="bold text-brand">{0}</span> thuộc <span class="bold text-brand">{1}</span>. Bạn không được phép thêm nội dung trùng tên cùng thuộc <span class="bold text-brand">{2}</span>.',
    DuplicateNameNotParent:
      'Đã tồn tại <span class="bold text-brand">{0}</span> trong danh mục. Bạn không được phép thêm nội dung trùng tên.',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác. Xin vui lòng nạp lại.',
    DeleteMultiHasMultiArisened: 'Có một số bản ghi xuất hiện lỗi trong quá trình xóa.', // Chi tiết xem phía dưới: "[ {0} ]
    DeleteMultiHasMultiArisened2: 'Có một số bản ghi đã có phát sinh. Không thể xóa!',
    ConfirmDeleteMultiHasMultiArisened: 'Có một số bản ghi đã có phát sinh. Bạn có muốn tiếp tục xóa không!',
    DeleteMultiHasOneArisened: 'Có một bản ghi đã có phát sinh. Không thể xóa!', // <{0}>
    DeleteMultiHasOneArisenedComponentAsset: 'Linh kiện đã có phát sinh, bạn không thể xóa!', // <{0}>
    NotPermission: 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại!',
    ManagerUnitHasArise: 'Đơn vị quản lý đã có phát sinh dữ liệu, bạn không thể bỏ check là đơn vị quản lý.',
    ParentUnitHasArise:
      'Đơn vị quản lý cấp cha của đơn vị này đã có phát sinh dữ liệu đã, bạn không thể đặt là đơn vị quản lý.',
    ManagerUnitHasDependent:
      'Đơn vị đã có phát sinh đơn vị con là đơn vị quản lý, bạn không thể bỏ check là đơn vị quản lý.',
    NewMessageDelete: '{0} <{1}> đã có phát sinh. Bạn có muốn tiếp tục xóa không?',
    Required: 'Nhập thiếu thông tin {0}',
    Arise:
      '{0} tổng hợp đã phát sinh dữ liệu. Do vậy, để thêm mới được <span class="text-brand">{1}</span> , hệ thống phải chuyển toàn bộ dữ liệu gắn với {0} <span class="text-brand">{2}</span> sang cho {0} <span class="text-brand">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    AriseAccount:
      'Hệ thống không cho phép hạch toán vào TK tổng hợp. Do vậy, để thêm mới được tài khoản <span class="text-brand">{1}</span> , hệ thống phải chuyển toàn bộ dữ liệu gắn với tài khoản <span class="text-brand">{2}</span> sang <span class="text-brand">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    StartThanEndDate: 'Ngày kết thúc phải lớn hơn Ngày bắt đầu',
    Delete_ErrorIsPostedVoucher: 'Chứng từ này có liên quan đến chứng từ {0}. Bạn có muốn xóa không?',
    FromYearNotGreaterThanToYear: 'Đến năm phải lớn hơn hoặc bằng từ năm',
    EmptyDataDicSource: 'Dữ liệu chi tiết nguồn không được để trống',
    DefaultApprovalDecision: 'Số QĐ…ngày…/tháng…/năm…',
    RateOverHundred: 'Tổng tỉ lệ không vượt quá 100%',
    EstimateDuplicateDetail: 'Không được phép nhập các dòng có thông tin chi tiết giống nhau.',
    DuplicateFormName: 'Tên mẫu <strong>{0}</strong> đã bị trùng trong danh sách. Vui lòng kiểm tra lại.',
    Attachment: 'Đính kèm không thành công',
    DataIsEnact:
      'Nội dung <span class="text-bold">{0} </span> - <span class="text-bold">{1} </span> đã được ban hành cho đơn vị cấp dưới. Để đảm bảo tính đồng nhất, vui lòng ban hành lại các danh mục có chỉnh sửa, bổ sung thông tin.',
    DataIsArise:
      'Hệ thống không cho phép lập dự toán cho nội dung tổng hợp. Hệ thống sẽ chuyển toàn bộ dữ liệu gắn với nội dung <span class="text-bold">{0} </span> - <span class="text-bold">{1} </span> vào nội dung <span class="text-bold">{2} </span> - <span class="text-bold">{3} </span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    DataIsAriseCalculationBasis:
      'Hệ thống không cho phép lập dự toán cho nội dung tổng hợp. Hệ thống sẽ chuyển toàn bộ dữ liệu gắn với nội dung <span class="text-bold">{1} </span> vào nội dung <span class="text-bold">{1} </span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    DataHasExplanationFormNotArise:
      'Hệ thống không cho phép gắn thuyết minh nội dung tổng hợp. Hệ thống sẽ chuyển thuyết minh đã gắn với nội dung <span class="text-bold">{0} </span> - <span class="text-bold">{1} </span> vào nội dung <span class="text-bold">{2} </span> - <span class="text-bold">{3} </span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    DataHasExplanationFormAndArise:
      'Hệ thống không cho phép lập dự toán và thuyết minh cho nội dung tổng hợp. Hệ thống sẽ chuyển toàn bộ dữ liệu và thuyết minh gắn với nội dung <span class="text-bold">{0} </span> - <span class="text-bold">{1} </span> vào nội dung <span class="text-bold">{2} </span> - <span class="text-bold">{3} </span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    DataEnactArise:
      'Nội dung <span class="text-bold">{0} </span> đã phát sinh dữ liệu bên hướng dẫn lập dự toán. Bạn không thể thay đổi thông tin <span class="text-bold">Thuộc nội dung</span> của danh mục.',
    AreaDuplicate: 'Trùng tên địa bàn, vui lòng kiểm tra lại.',
    AreaEmpty: 'Địa bàn không được phép để trống.',
    DuplicateOrganizationGroup:
      'Đã tồn tại {0} <span class="bold text-brand">{1}</span> trong danh sách. Bạn không được phép thêm nội dung trùng {0}.',
    EmptyKindCode: 'Lĩnh vực không được để trống.',
  },
  Detail: {
    SubmitError: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ.',
    AddDetail: 'Thêm dòng',
    SaveSuccessMessage: 'Lưu thành công',
  },
  Title: {
    GetDataFromBeginYear: 'Lấy số liệu từ Lập dự toán nhu cầu',
  },
  Message: {
    ConfirmDeleteTitle: 'Xóa {0}',
    ConfirmDeleteVoucherTitle: 'Xóa chứng từ',
    ConfirmDeleteVoucher: 'Bạn có muốn xóa chứng từ <span class="text-brand">{0}</span> không?',
    ConfirmDelete: 'Bạn có muốn xóa {0} <span class="text-brand">{1}</span> không?',
    ConfirmDeleteLv:
      'Bạn có chắc chắn xóa <span class="text-bold">{0}</span> và các nội dung chi đã phát sinh của lĩnh vực này không?',
    ConfirmDeleteField: 'Bạn có chắc chắn xóa lĩnh vực <span class="text-bold">{0}</span> này không?',
    ConfirmDeleteEstimateTitle: 'Xóa nội dung khỏi bảng dự toán?',
    ConfirmDeleteAllocationTitle: 'Xóa nội dung khỏi bảng phân bổ dự toán?',
    ConfirmDeleteEstimateBeforeTitle: 'Xóa nội dung?',
    ConfirmDeleteEstimateArrgrateThreeYearTitle: 'Xóa nội dung khỏi bảng dự toán?',
    ConfirmDeleteEstimate: 'Bạn có chắc chắn xóa nội dung <span class="text-bold">{0}</span> không?',
    ConfirmDeleteEstimateThreeYear: 'Bạn có chắc chắn xóa nội dung <span class="text-bold">{0}</span>',
    ConfirmDeleteEstimateThreeYearFinance: 'Bạn có chắc chắn xóa nội dung <span class="text-bold">{0}</span>?',
    DeleteEstimateFail: 'Xóa nội dung thu khỏi bảng dự toán không thành công',
    DeleteEstimateRevenueBusinessFail:
      'Nội dung <b>{0}</b> đã lập dự toán Chi từ . Vui lòng xóa số liệu trước khi xóa nội dung thu này khỏi bảng dự toán.',
    DeleteThreeYearEstimateFail: 'Xóa nội dung khỏi bảng dự toán?',
    DeleteThreeYearEstimateRevenueBusinessFail:
      'Đã phát sinh dự toán chi từ nội dung <b>{0}</b>, bạn có chắc chán muốn xóa không?',
    ConfirmDeleteEstimateArise:
      'Nội dung <span class="text-bold">{0}</span> đã lập dự toán <span class="text-bold">{1}</span>. Khi xóa hệ thống sẽ tự động xóa các dữ liệu phát sinh liên quan. Bạn có chắc chắn xóa không?',
    ConfirmDeleteEstimateAriseParent:
      'Nội dung <span class="text-bold">{0}</span> đã phát sinh dữ liệu ở nội dung chi tiết. Khi xóa hệ thống sẽ tự động xóa tất cả các dữ liệu phát sinh liên quan. Bạn có chắc chắn xóa không?',
    ConfirmDeleteRevenueBusinessAriseChild:
      'Nội dung <span class="text-bold">{0}</span> đã phát sinh dữ liệu ở nội dung chi tiết.',
    ConfirmDeleteDictionary: 'Bạn có chắc chắn muốn xóa nội dung <span class="text-bold">{0}</span> không?',
    ConfirmDeleteExplanationForm: 'Bạn có chắc chắn muốn xóa thuyết minh <span class="text-bold">{0}</span> không?',
    ConfirmDeleteMuti: 'Bạn có chắc chắn muốn xóa <span class="text-bold">{0} nội dung</span> đã chọn không?',
    DataChange: 'Dữ liệu đã thay đổi',
    ConfirmSaveChangeIsSave: 'Dữ liệu đã có thay đổi, bạn có muốn Lưu không?',
    ConfirmSaveChangeIsClose: 'Dữ liệu đã có thay đổi, bạn có chắc chắn Hủy không?',
    NotSelected: 'Vui lòng chọn <span class="text-brand">ít nhất 1 bản ghi</span> để thực hiện được chức năng này.',
    NotSelectedAllocationDecision:
      'Vui lòng chọn <span class="text-brand">ít nhất 1 chỉ tiêu</span> để thực hiện được chức năng này.',
    Exception: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ',
    DeleteSuccess: 'Xóa thành công',
    DeleteFail: 'Xóa thất bại',
    WarningTitle: 'Cảnh báo',
    SaveSuccess: 'Lưu thành công',
    SaveDataSuccess: 'Lưu dữ liệu thành công',
    SaveSuccessSortByRegular: 'Sắp xếp nhiệm vụ theo danh mục thành công',
    SaveSuccessSortByField: 'Sắp xếp theo lĩnh vực thành công',
    PostedSuccess: 'Ghi sổ thành công',
    SavePostedSuccess: 'Cất và ghi sổ thành công',
    UnPostedSuccess: 'Bỏ ghi sổ thành công',
    Developing: 'Chức năng đang được phát triển',
    DeleteWarningTitle: 'Không thể xóa',
    WarningBatchExcution: 'Không hợp lệ',
    ValidateInvalidTitle: 'Không hợp lệ',
    UpdateAmountWarning: 'Không thể cập nhật số dự toán',
    FailSave: 'Lưu không thành công',
    FailSaveForAdd: 'Thêm danh mục không thành công',
    FailSaveForAddOrganizationGroup: 'Thêm nhóm đơn vị không thành công',
    FailSaveForUpdate: 'Sửa danh mục không thành công',
    ValidateBusinessTitle: 'Chứng từ không hợp lệ',
    ValidateBusiness: 'Vui lòng nhập ít nhất một dòng chứng từ chi tiết',
    ErrorSystemDeleteMulti: '{0} đã chọn là dữ liệu thuộc hệ thống',
    ConfirmErrorSystemDelete: '{0} <span class="text-brand">{1}</span> đã chọn là dữ liệu thuộc hệ thống',
    ConfirmErrorDeleteTitle: 'Không thể xóa',
    WarningIncurredDataTitle: 'Xóa không thành công',
    WarningSelectNotSuccessTitle: 'Chọn không thành công',
    WarningIncurredDataContent:
      '{0} <span class="text-brand">{1}</span> đã có phát sinh dữ liệu. Bạn phải xóa các phát sinh liên quan trước khi xóa <span class="text-brand">{2}</span>',
    WarningIncurredDataEstimateContent:
      '{0} <span class="text-bold">{1}</span> đã có phát sinh dữ liệu. Bạn phải xóa các phát sinh liên quan trước khi xóa <span class="">{2}</span>',
    WarningIncurredDataContentCustom:
      '{0} <span class="text-brand">{1}</span> đã có số dư ban đầu; đã phát sinh trên các chứng từ. Bạn phải xóa các phát sinh liên quan trước khi sửa thông tin chi tiết theo.',
    WarningParallelNotValidRule:
      'Thông tin hạch toán đồng thời không phù hợp với quy tắc thiết lập hạch toán đồng thời. Bạn có muốn cập nhật hạch toán đồng thời không?',

    DeleteRelation:
      'Chứng từ số <span class="text-brand">{0}</span> có liên quan đến chứng từ số <span class="text-brand">{1}</span>. Bạn có muốn xóa chứng từ liên quan này không?',
    DeleteRelationTitle: 'Xóa chứng từ',
    DeleteRelationMulti:
      'Chứng từ số <span class="text-brand">{0}</span> có liên quan đến chứng từ số <span class="text-brand">{1}</span>. </br>',
    ConfirmDeleteRelation: 'Bạn có muốn xóa chứng từ liên quan này không?',
    GetDefaultSettingLayoutSuccess: 'Lấy tùy chỉnh giao diện mặc định thành công',
    UpdateSuccess: 'Cập nhật thành công',
    FailUpdate: 'Cập nhật không thành công',
    WarningDataNotValid: 'Không được thêm mới nội dung con của nội dung <span class="text-brand">{0} - {1}</span>.',
    WarningDataNotValidSystem: 'Không được thêm mới cơ sở tính con vào <span class="text-brand">{0}</span> .',
    WarningIncurredPattern: 'Nội dung nằm trong Mẫu lập dự toán chi thường xuyên.',
    ConfirmDeleteEnactArise:
      '<span class="text-bold">{0}</span> nằm trong hướng dẫn lập dự toán. Nếu xóa hệ thống sẽ loại bỏ <span class="text-bold">{0}</span> khỏi hướng dẫn lập dự toán. Bạn có chắc chắn muốn xóa không?',
    ConfirmDeleteMultiEnactArise1:
      '<span class="text-bold">{0} nội dung</span> nằm trong hướng dẫn lập dự toán. Nếu xóa hệ thống sẽ loại bỏ <span class="text-bold">{0} nội dung</span> khỏi hướng dẫn lập dự toán. Bạn có chắc chắn muốn xóa không?',
    ConfirmDeleteMultiEnactArise2:
      'Bạn có chắc chắn xóa <span class="text-bold">{0} nội dung</span> được chọn , trong đó có <span class="text-bold">{1} nội dung</span> đã ban hành xuống cấp dưới không?',
    ApproveDictionarySuccess: 'Đã phê duyệt nội dung danh mục',
    WarningEstimateRevenueOtherTitle: 'Tính số thu bổ sung không thành công',
    WarningEstimateRevenueOther:
      'Nội dung <span class="bold">Thu bổ sung cân đối ngân sách</span> hoặc <span class="bold">Thu bổ sung có mục tiêu</span> chưa được chọn. Vui lòng chọn các chỉ tiêu này trước khi thực hiện chức năng.',
    WarningEstimateRevenueOtherHasChild:
      'Nội dung <span class="bold">Thu bổ sung cân đối ngân sách</span> hoặc <span class="bold">Thu bổ sung có mục tiêu</span> đã khai báo nội dung con chi tiết. Chương trình không thể tính tự động số thu bổ sung.',
    CreateAuditSuccess: 'Tạo biên bản kiểm tra thành công',
    CreateAuditFail: 'Tạo biên bản kiểm tra không thành công',
    NotAllowSyncPatternRegular:
      'Vui lòng đồng bộ hết các nội dung danh mục trước khi thực hiện đồng bộ Mẫu lập dự toán chi thường xuyên',
    FailSaveAttachment: 'Lưu đính kèm không thành công',
    FailDeleteAttachment: 'Xóa đính kèm không thành công',
    WarningSalaryAmount: 'Số dự toán hiển thị sai định dạng nên không thể cập nhật. Vui lòng liên hệ cấp trên',
    WarningThreeYearAmountExists:
      'Đã phát sinh dữ liệu dự toán 3 năm. Bạn có chắc chắn muốn thay thế toàn bộ dữ liệu đã phát sinh bằng dự toán nhu cầu?',
    WarningEstimateArrgrateThreeYearAmountExists:
      'Đã phát sinh dữ liệu, bạn có muốn lập dự toán theo dự toán nhu cầu không?',
    CreateSubmitError: 'Bạn chưa hoàn thành kiểm tra tất cả các đơn vị cấp dưới. Vui lòng kiểm tra lại.',
    CreateSubmitErrorTitle: 'Không thể tạo lần nộp',
    EmptyListForAction: 'Không có Mục - Tiểu mục nào thỏa mãn điều kiện để thêm vào danh mục.',
    GetSuccess: 'Lấy dữ liệu thành công',
    ValidateContent: 'Vui lòng chọn ít nhất 2 nội dung đưa vào chỉ tiêu tổng hợp',
    AutomaticallySuccess: 'Lấy số dự toán chi từ nguồn bổ sung mục tiêu thành công',
    AutomaticallyFail: 'Lấy số dự toán chi từ nguồn bổ sung mục tiêu không thành công. Vui lòng kiểm tra lại dữ liệu',
    SaveSuccessManager: 'Thêm người dùng thành công',
    ConfirmDeleteUser:
      'Người dùng <span class="text-bold">{0}</span> sẽ bị xóa và không thể khôi phục. Bạn muốn tiếp tục?',
    ConfirmUpdateGrade:
      'Chương trình sẽ tự động cập nhật cấp của các CTMT, dự án con thành <span class="bold">{0}</span>. Bạn có muốn lưu không?',
    ConfirmUpdateGradeTiltle: 'Cập nhật cấp Chương trình mục tiêu, dự án',
  },
  MessageDeleteParentNode: {
    DeleteWarningParentTitle: 'Xóa không thành công',
    DeleteWarningParentContent:
      '{0} <span class="text-brand>{1}</span> là danh mục tổng hợp. Vui lòng xóa các danh mục chi tiết trước khi xóa danh mục tổng hợp.',
  },
  Voucher: {
    GenerateVoucher:
      'Không sinh được giấy rút dự toán từ hạch toán chi tiết của chứng từ này. Vui lòng kiểm tra lại dữ liệu cột TK Có và cột Nghiệp vụ.',
    GenerateVoucherTitle: 'Không hợp lệ',
    ConfirmSyncVocherContent:
      'Bạn có muốn đồng bộ các thông tin đã cập nhật trên chứng từ {0} này sang giấy rút dự toán số <span class="text-brand">{1}</span> không?',
    ConfirmSyncVocherTitle: 'Đồng bộ chứng từ',
  },
  Switch: {
    SwitchDBSuccess: 'Chuyển dữ liệu năm ngân sách thành công',
    SwitchDBErr: 'Chuyển dữ liệu năm ngân sách không thành công',
    SwitchTenantSuccess: 'Chuyển thuê bao thành công',
    SwitchTenantErr: 'Chuyển thuê bao không thành công',
  },
  PlaceHolder: {
    SearchDictionary: 'Nhập mã, tên nội dung cần tìm kiếm',
    SearchOrg: 'Nhập Mã QHNS, Tên đơn vị để tìm...',
    SearchExpenseBusiness: 'Nhập nội dung cần tìm kiếm',
    SearchEstimateArrgrateThreeYear: 'Nhập Nội dung cần tìm kiếm...',
    SearchExplanationForm: 'Nhập Mã, Tên thuyết minh để tìm kiếm',
    SearchAllocationDecision: 'Nhập từ khóa tìm kiếm',
    SearchOrganizationUnder: 'Nhập tên đơn vị tìm kiếm',
  },
  Button: {
    Add: 'Thêm mới',
    Close: 'Đóng',
  },
  MessageDeleteSystemData: {
    DeleteSystemDataTitle: 'Xóa không thành công',
    DeleteSystemDataContent: 'Đây là dữ liệu hệ thống. Bạn không thể xóa.',
    DeleteEnactContent: '<span class="text-bold">{0}</span> do cấp trên ban hành. Bạn không thể xóa.',
  },
  SubTitle: {
    DictionaryPatternRegular:
      'Hãy đảm bảo mẫu bạn tạo ra phải bao gồm đầy đủ các nội dung mà cấp dưới cần để lập dự toán.',
    ExpenseRevenueBusiness: 'Bạn cần lập dự toán thu trước khi lập dự toán chi từ nguồn Thu HĐSN, Dịch vụ.',
    BeforeDeleteDataEstimateBusiness: `Nội dung <span class="text-bold">{0}</span> đã lập dự toán Chi từ nguồn thu HĐSN, dịch vụ.`,
    BeforeDeleteDataEstimateArrgrateThreeYear: `Đã phát sinh dự toán chi từ nội dung <span class="text-bold">{0}</span>, bạn có chắc chắn muốn xóa không?`,
  },
};
